@import "../../../css/_mixins.scss";

.stepLabel {

  display: flex;
  margin-left: 40vw;
  margin-right: 10px;
  justify-content: space-between;
  align-items: center;
  min-height: 80px;
  padding: 14px 0;
  font-size: 42px;
  line-height: 1.15;
  color: var(--white);
  letter-spacing: -0.78px;
  white-space: nowrap;

  @include small-desktop {
    min-height: 70px;
    padding: 12px 0;
    font-size: 36px;
  }

  @include tablet {
    min-height: 60px;
    padding: 10px 0;
    font-size: 30px;
  }

  @media (max-width: 700px) {
    font-size: 28px;
    letter-spacing: -1px;
  }

  @include mobile {
    min-height: 56px;
    padding: 10px 0;
    font-size: 24px;
  }

  .checkoutLabel{
    margin-inline: 10px;
    font-size: 16px;
    align-self: flex-end;
    position: relative;
    margin-bottom: -5px;
  }

  @media (max-width: 1000px) {
    position: relative;
    right: 50%;
    justify-content: space-around;
    width: 100vw;
  }

  .btnMultiRedeem {
    font-size: 55%;
    cursor: pointer;

  }
}

.btnContinue {
  width: 20%;
  margin-top: 16px;

  @include tablet {
    margin-top: 44px;

    @include mobile {
      width: 100%;
    }
  }
}